import Result from './Result';

export default Result
export { Result as Base }
